import { IMG } from "./site";

export const REVIEWS = [
  {
    name: "Joseph Shamara",
    role: "Homeowner",
    when: "2 months ago",
    text: "Amazing experience. Great prices, and professional install and on time delivery. CJ was great to work with and quick with responses. His install team came in with everything needed to get the job done. We love the new flooring! 20ml planks feel very high quality.",
  },
  {
    name: "Amanda Gomez",
    role: "Homeowner",
    when: "2 months ago",
    text: "As a rookie to flooring and the renovation process, I couldn't have asked for a better experience. CJ was incredibly knowledgeable, patient, and professional…",
  },
  {
    name: "Brandon Lowery",
    role: "Homeowner · Full home remodel",
    when: "2 years ago",
    text: "Chris and CJ (owners) did a great job with continual communication through a 6 month full home remodel. We installed LVP in 4 bedrooms, living room, office, kitchen, hallways, laundry room, newly configured closet, and landing area…",
  },
];

export const FAQS = [
  { q: "Is wholesale flooring really cheaper than big-box flooring stores?", a: "Yes. Because we sell at wholesale pricing instead of adding a traditional retail markup, customers typically pay 40–50% less than big-box store pricing for comparable quality flooring." },
  { q: "Do you install flooring?", a: "Yes. We offer professional luxury vinyl plank installation, so homeowners can buy their LVP and have it installed by one company." },
  { q: "Do you sell flooring directly to homeowners?", a: "Absolutely. Homeowners can buy flooring directly from us at wholesale pricing, with or without installation." },
  { q: "Do you work with general contractors?", a: "Yes. We supply general contractors, builders, remodelers, flooring installers, investors and property managers with contractor and volume pricing." },
  { q: "Can you deliver flooring to a jobsite?", a: "In many cases, yes. We coordinate flooring delivery to project sites throughout the Lake Norman and greater Charlotte area whenever possible." },
  { q: "What areas do you serve?", a: "We serve Huntersville, Cornelius, Denver, Sherrills Ford, Iron Station and surrounding Lake Norman and greater Charlotte communities." },
  { q: "Do you carry waterproof LVP?", a: "Yes. We carry waterproof luxury vinyl plank options suited to kitchens, bathrooms, basements, rentals and busy households." },
  { q: "Can I get a free flooring estimate?", a: "Yes. Request a free estimate online or call (980) 222-4348 and we'll help you plan your project and pricing." },
];

// Offline fallback only. Live products are managed in the owner dashboard (GET /api/products).
export const INSTALL_PRICE = "1.75";
const P = (n, name, tag, thickness, wear_layer, price, price_max, count) => ({
  id: `p${n}`, name, tag, thickness, wear_layer, price, price_max, featured: true,
  swatches: Array.from({ length: count }, (_, i) => ({ name: `Color ${i + 1}`, image: `/img/products/p${n}-${i + 1}.webp`, thumb: `/img/products/p${n}-${i + 1}-t.webp` })),
});
export const PRODUCTS = [
  P(1, "5mm 12 mil LVP", "Special", "5mm", "12 mil", "1.89", null, 5),
  P(2, "5mm 12 mil LVP", null, "5mm", "12 mil", "2.04", null, 6),
  P(3, "5mm 12 mil LVP", null, "5mm", "12 mil", "2.14", null, 6),
  P(4, "5mm 20 mil LVP", null, "5mm", "20 mil", "2.24", null, 32),
  P(5, "5mm 12 mil / 6.5mm 20 mil LVP", null, "5mm / 6.5mm", "12 mil / 20 mil", "2.14", "2.64", 29),
  P(6, "8mm 28 mil LVP", "Premium", "8mm", "28 mil", "3.19", null, 7),
  P(7, "5mm 20 mil / 8mm 22 mil LVP", null, "5mm / 8mm", "20 mil / 22 mil", "2.44", "2.84", 10),
];

export const GALLERY_CATS = ["All", "LVP", "Whole-home", "Remodels", "New construction", "Contractor projects"];

// Sample stock imagery until real project photos are supplied. Each item carries its own ALT text.
export const GALLERY = [
  { id: "g1", image: IMG.hero, cat: "Whole-home", title: "Open living space", alt: "Wide-plank wood-look flooring in a bright open living room with fireplace" },
  { id: "g2", image: IMG.lvp, cat: "LVP", title: "Vaulted great room", alt: "Light oak luxury vinyl plank in a vaulted great room" },
  { id: "g3", image: IMG.oak, cat: "Whole-home", title: "Sunlit living room", alt: "Rich wood-look luxury vinyl plank in a sunlit living room with tall windows" },
  { id: "g4", image: IMG.bright, cat: "LVP", title: "Bright open plan", alt: "Light luxury vinyl plank flowing through a bright open-plan home" },
  { id: "g5", image: IMG.remodel, cat: "Remodels", title: "Remodel in progress", alt: "Rustic plank flooring during a home remodel with tools on the floor" },
  { id: "g6", image: IMG.construction, cat: "New construction", title: "New build", alt: "New construction home interior prepared for flooring" },
  { id: "g7", image: IMG.install, cat: "Contractor projects", title: "Plank install", alt: "Installer fitting vinyl planks in a new room" },
  { id: "g8", image: IMG.kitchen, cat: "LVP", title: "Kitchen LVP", alt: "Waterproof luxury vinyl plank in a modern kitchen" },
  { id: "g9", image: IMG.oak2, cat: "Remodels", title: "Living room refresh", alt: "Mid-tone luxury vinyl plank in a modern living room" },
];
